import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import { BUTTON_SIZE, BUTTON_TYPE, ButtonGroup, LoaderButton } from '../../generic';
import Button from '../../generic/Button';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
};

/**
 * Confirmation dialog for removing a published SBOM from the organization
 * portal. The SBOM can be republished at any time.
 */
export const UnpublishReportDialog: VoidFunctionComponent<Props> = ({ onClose, onConfirm, isLoading }) => (
  <Modal onHide={onClose} className="modal-confirm" show>
    <Modal.Header closeButton>
      <Modal.Title>Unpublish SBOM</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>This will remove the SBOM for this release version from the portal. You can republish it at any time.</p>
    </Modal.Body>
    <Modal.Footer>
      <ButtonGroup>
        <Button type="secondary" size={BUTTON_SIZE.MEDIUM} onClick={onClose}>
          Cancel
        </Button>
        <LoaderButton
          isLoading={isLoading}
          type={BUTTON_TYPE.PRIMARY}
          size={BUTTON_SIZE.MEDIUM}
          onClick={onConfirm}
        >
          Unpublish
        </LoaderButton>
      </ButtonGroup>
    </Modal.Footer>
  </Modal>
);
